module.exports = __webpack_public_path__ + "static/media/6.722b5f51.webp";